'use strict'
import ctrlTranslate from '../app/translate/translate.ctrl'

export default (term, screen) => {
    if (!screen || !term) return term
    return ctrlTranslate(screen, term)
}